import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from './Components/Header';
import ItemDetailDrawer from './ItemDetailDrawer';
import { formInput, clearFormInput } from 'actions/FormActions';
import { GetProductInventoryLog, getMultiBranchInventory, getProductCategoriesDropdown, getSingleBranchInventory } from 'actions/EntityActions';
import { getUserBranches } from 'actions/CommonActions';
import { getCsvReport } from 'actions/ReportsAction';
import "./styles/multiStore.css";
import imgDefault from 'images/imgDefault.jpg';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Pagination from 'screens/components/basic/Pagination';
import { multiStoreCrumb } from 'utils/breadcrumbInfo';
import { columnOptions } from './data';
import Legend from './Components/Legend';
import Grid from 'screens/components/basic/Grid';
import CardSimple from 'screens/components/basic/CardSimple';
import PageHeaderWithButton from 'screens/components/basic/PageHeaderWithButton';

const componentName = "MultiStoreInventory";

class multiStoreManagement extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      activePage: 1,
      itemsPerPage: 20,
      isOpenDrawer: false
    };

    this.getBranchInfo = this.getBranches.bind(this);
    this.generateTableData = this.generateTableData.bind(this);
    this.generateCategories = this.generateCategories.bind(this);
    this.handleCellClick = this.handleCellClick.bind(this);
    this.getMultiBranchInventoryData = this.getMultiBranchInventoryData.bind(this);
  }

  componentWillMount() {

    this.getMultiBranchInventoryData();
    this.props.getProductCategories();
  }

  componentDidMount() {
    this.props.formInput(columnOptions, `ColumnOptions`);
  }

  componentDidUpdate(prevProps) {
    if (
      (prevProps.refreshWarehouses === null && this.props.refreshWarehouses !== null) ||
      (prevProps.refreshInventoryAdjust === null && this.props.refreshInventoryAdjust !== null) ||
      (prevProps.refreshWarehouses !== null && prevProps.refreshWarehouses !== this.props.refreshWarehouses) ||
      (prevProps.refreshInventoryAdjust !== null && prevProps.refreshInventoryAdjust !== this.props.refreshInventoryAdjust)
    ) {
      this.getMultiBranchInventoryData();
      this.getSingleBranchInventoryData();
    }

    if ((prevProps.reStockCapSet === null && this.props.reStockCapSet !== null) ||
      (prevProps.reStockCapSet !== null && prevProps.reStockCapSet !== this.props.reStockCapSet)) {
      this.getMultiBranchInventoryData();
      this.getSingleBranchInventoryData();
    }

    if ((prevProps.selectedType === null && this.props.selectedType !== null) ||
      (prevProps.selectedType !== null && prevProps.selectedType !== this.props.selectedType)) {
      this.getMultiBranchInventoryData();
      this.props.getProductCategories();
    }

    if ((prevProps.selectedCategory === null && this.props.selectedCategory !== null) ||
      (prevProps.selectedCategory !== null && prevProps.selectedCategory !== this.props.selectedCategory)) {
      this.getMultiBranchInventoryData();
    }

    if (prevProps.typeOfCatergories !== this.props.typeOfCatergories) {
      if (this.props.typeOfCatergories !== "all") {
        this.props.getProductCategories(this.props.typeOfCatergories);
      } else {
        this.props.getProductCategories();
      }
    }
  }

  handleRequestChange = (open) => this.setState({ isOpenDrawer: open });
  toggleDrawer = () => this.setState({ isOpenDrawer: !this.state.isOpenDrawer });

  getMultiBranchInventoryData = () => {
    const localBranchIds = JSON.parse(localStorage.getItem("branchIds"));
    const selectedBranches = this.props.selectedBranches ? [...this.props.selectedBranches].sort((a, b) => a - b) : [];
    const model = {
      ProductIdentifier: this.props.searchText || "",
      CategoryId: (!this.props.selectedCategory || this.props.selectedCategory === "all") ? null : this.props.selectedCategory,
      BranchIds: selectedBranches.length === 0 ? localBranchIds : selectedBranches,
      showOnlyInStock: this.props.showStock === "inStock" ? true : false,
      isCannabis: this.props.selectedType === "all" ? null : this.props.selectedType,
      ItemsPerPage: this.props.itemsPerPage || 20,
      PageNumber: this.state.activePage
    }
    this.props.getMultiBranchInventory(model);
  }

  getSingleBranchInventoryData = () => {
    const model = {
      ProductId: this.props.clickedProduct,
      ProductIdentifier: "",
      CategoryId: null,
      isCannabis: null,
      BranchIds: [this.props.clickedBranch],
      showOnlyInStock: false,
      ItemsPerPage: 20,
      PageNumber: 1
    }
    this.props.getSingleBranchInventory(model)
  }

  search = () => {
    this.setState(pState => {
      return {
        ...pState,
        activePage: 1
      };
    }, () => this.getMultiBranchInventoryData());
  }

  cleanSearch = () => {
    this.props.clearFormInput(`${componentName}Search`);
    this.search();
  }

  changePage = (e) => {
    this.setState(pState => {
      return {
        ...pState,
        activePage: e
      };
    }, () => this.getMultiBranchInventoryData());
  }

  getBranches() {
    const selectedBranches = this.props.selectedBranches ? [...this.props.selectedBranches] : [];
    const allBranches = this.props.branches ? [...this.props.branches] : [];
    if (this.props.selectedBranches && selectedBranches.length === 0) return selectedBranches;
    if (selectedBranches.length > 0) {
      const userSelectedBranches = allBranches.filter(item => selectedBranches.includes(item.id.toString())).map(item => { return { id: item.id, name: item.name } })
      return userSelectedBranches;
    }
    return allBranches.map(b => ({ id: b.id, name: b.name }));
  }

  getColumns() {
    const selectedCols = this.props.selectedColumns ? [...this.props.selectedColumns] : [];
    const allCols = this.props.columns ? [...this.props.columns] : [];

    if (selectedCols.length > 0) {
      return allCols.filter(obj => selectedCols.includes(obj.value)).map(obj => ({ ...obj }));
    }
    return allCols;
  }

  generateTableData(data, branches, columns) {
    return data.list.map(product => {
      const formattedProduct = { id: product.productId, reStockQty: product.reStockCap };
      columns.map(col => {
        formattedProduct[`${col.value}`] = product[`${col.value}`]
      })
      branches.forEach(branch => {
        const branchInventory = product.singleBranchInventoryDTO.find(inv => inv.branchId == branch.id)
        formattedProduct[branch.id] = branchInventory ? [branchInventory.quantity, branchInventory.storeQty, branchInventory.storageQty, branchInventory.damageQty] : [0, 0, 0, 0];
      });
      return formattedProduct;
    });
  }

  condtionalColor(reStockCap, invLevel) {
    const capSet = reStockCap === 0 ? false : true;
    if (!capSet && invLevel > 0) return 'inventoryCell green';
    if (!capSet && invLevel === 0) return 'inventoryCell';
    if (capSet && invLevel > reStockCap) return 'inventoryCell green';
    if (capSet && invLevel < reStockCap && invLevel > 0) return 'inventoryCell yellow';
    if (capSet && invLevel === 0) return 'inventoryCell red';
  }

  generateCategories(data) {
    let categories = data.map(category => ({ text: category.name, value: category.id }));
    categories.unshift({ text: 'All', value: "all" });
    return categories;
  }

  handleCellClick = async (product, branch) => {
    await this.props.GetProductInventoryLog({
      ProductId: product.id,
      BranchId: branch.id,
      StartDate: this.props.StartDate,
      EndDate: this.props.EndDate,
      Reason: null,
      ItemsPerPage: this.props.itemsPerPage || 20,
      PageNumber: this.state.activePage
    })

    this.props.formInput(product.id, "clickedProduct")
    this.props.formInput(branch.id, "clickedBranch")
    this.props.formInput(this.props.StartDate, "fromDate")
    this.props.formInput(this.props.EndDate, "toDate")

    this.props.getSingleBranchInventory({
      ProductId: product.id,
      ProductIdentifier: "",
      CategoryId: null,
      isCannabis: null,
      BranchIds: [branch.id],
      showOnlyInStock: false,
      ItemsPerPage: 20,
      PageNumber: 1
    })

    this.setState(pState => ({
      ...pState,
      isOpenDrawer: !this.state.isOpenDrawer,
      clickedProduct: { clickedProduct: product, clickedBranchName: branch.name }
    }));
  }

  download = () => {
    const localBranchIds = JSON.parse(localStorage.getItem("branchIds"));
    const selectedBranches = this.props.selectedBranches ? [...this.props.selectedBranches].sort((a, b) => a - b) : [];

    let productIdentifier = this.props.searchText || "";
    let categoryId = (!this.props.selectedCategory || this.props.selectedCategory === "all") ? null : this.props.selectedCategory;
    let branchIds = selectedBranches.length === 0 ? localBranchIds.join(",") : selectedBranches.join(",");
    let showOnlyInStock = this.props.showStock === "inStock" ? true : false;
    let isCannabis = this.props.selectedType === "all" ? null : this.props.selectedType;

    this.props.getCsvReport(`warehouses/multiBranchInventoryDownload?productIdentifier=${productIdentifier}&categoryId=${categoryId}&branchIdString=${branchIds}&showOnlyInStock=${showOnlyInStock}&isCannabis=${isCannabis}`, "multiStoreManagement");

  }

  sortLog = (logData) => {
    // Sort deduction first and then addition for transfers
    const sortedData = [...logData].sort((a, b) => {
      if (a.modifiedDate === b.modifiedDate) {
        const diffA = a.newQuantity - a.previousQuantity;
        const diffB = b.newQuantity - b.previousQuantity;
        return diffB - diffA;
      }
      return 0;
    });
    return sortedData;
  }

  render() {
    const s = this.state;
    const p = this.props;
    const branches = this.getBranches();
    const columns = this.getColumns();
    const invData = this.props.multiStoreInventoryData ? this.props.multiStoreInventoryData : null;
    const tableData = invData ? this.generateTableData(invData, branches, columns) : null;
    const categoryOptions = p.categories ? this.generateCategories(p.categories) : [];
    const productInventoryByDate = this.props.productInventoryByDate ? this.sortLog(this.props.productInventoryByDate) : [];

    if (!tableData) {
      return null;
    }

    return (
      <Grid headerContent={multiStoreCrumb}>
        <PageHeaderWithButton title="Multi Store Inventory Management">
          <Legend />
        </PageHeaderWithButton>
        <CardSimple className="p-1">
          <Header
            branchOptions={p.branchOptions ? p.branchOptions : []}
            columnOptions={p.columns ? p.columns : []}
            categoryOptions={categoryOptions}
            componentName={componentName}
            search={this.search}
            clear={this.cleanSearch}
            getNewCategories={this.getNewCategories}
            download={this.download}
          />
        </CardSimple>
        {s.clickedProduct ?
          <ItemDetailDrawer
            open={s.isOpenDrawer}
            close={() => this.setState({ isOpenDrawer: false })}
            onRequestChange={this.handleRequestChange}
            product={s.clickedProduct}
            productInventoryByDate={productInventoryByDate}
            StartDate={this.props.StartDate}
            EndDate={this.props.EndDate}
            Reason={this.props.reason}
            getMultiBranchInventoryData={this.getMultiBranchInventoryData}
          /> : null}

        <CardSimple className="mainTableContainer">
          <TableContainer>
          <Table className='mainTable' bodyStyle={{ overflow: 'visible' }}>
            <TableHead className={'header'} displaySelectAll={false} adjustForCheckbox={false}>
              <TableRow>
                {columns.map(column => (
                  <TableCell style={{ width: `${column.width}` }} className={`${column.headerClassName}`} key={`header-${column.value}`}>
                    {column.text}
                  </TableCell>
                ))}
                {branches.map((branch, index) => (
                  <TableCell className={'headerCell'} key={`header-branch${index}`} style={{ width: '150px' }}>
                    {branch.name}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody displayRowCheckbox={false}>
              {tableData.map((product, index) => (
                <TableRow key={product.id}>
                  {columns.map(column => (<TableCell style={{ width: `${column.width}` }} className={`${column.rowClassName}`} key={`row-${column.value}`}>
                    {typeof column.rowValue === "function" ? (product.imageURL ? column.rowValue(product, product.imageURL) : column.rowValue(product, imgDefault)) : product[column.value]}
                  </TableCell>))}
                  {branches.map(branch => {
                    return (
                      <TableCell
                        key={`body-branch${branch.id}`}
                        id={`tablecell-${index}-${branch.id}`}
                        className={this.condtionalColor(product.reStockQty, product[`${branch.id}`][1])}
                        style={{ width: '150px', cursor: "pointer" }}
                        onClick={() => this.handleCellClick(product, branch)}>
                          {product[`${branch.id}`][1]}
                      </TableCell>
                    )
                  })}
                </TableRow>
              ))}
            </TableBody>
          </Table>

        </TableContainer>
            <Pagination
                length={!invData.total ? 0 : invData.total}
                itemsPerPage={this.props.itemsPerPage || 20}
                activePage={this.state.activePage}
                onPageChange={this.changePage}
                className={'pagination'}
            />
      </CardSimple>
    </Grid>
    )
  }
}

function formatDate(date) {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();

  return `${year}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day}`;
}

const mapStateToProps = state => {
  const branches = state.common.userBranches || [];
  const branchOptions = branches.map(b => ({ text: b.name, value: b.id.toString() }));
  const fromDate = state.form.fromDate && state.form.fromDate !== "" ? state.form.fromDate : formatDate(new Date(new Date().setDate(new Date().getDate() - 30)));
  const endDate = state.form.endDate && state.form.endDate !== "" ? state.form.endDate : formatDate(new Date());

  if (branches.length > 0) {
    const branchIds = branches.map(b => b.id);
    localStorage.setItem("branchIds", JSON.stringify(branchIds));
  }

  return {
    branches: branches,
    branchOptions: branchOptions,
    loggedBranch: state.common.branchId,
    selectedType: state.form[`${componentName}Type`],
    selectedCategory: state.form[`${componentName}Category`],
    selectedBranches: state.form[`${componentName}Locations`],
    selectedColumns: state.form[`${componentName}Columns`],
    itemsPerPage: state.form[`${componentName}ItemsPerPage`],
    searchText: state.form[`${componentName}Search`],
    showStock: state.form[`${componentName}Stock`],
    columns: state.form[`ColumnOptions`],
    categories: state.entity.productCategories,
    StartDate: fromDate,
    EndDate: endDate,
    multiStoreInventoryData: state.entity.multiStoreInventoryData,
    productInventoryByDate: state.entity.productInventoryByBranchAndDate ? state.entity.productInventoryByBranchAndDate.items : [],
    reason: state.form.reason ? state.form.reason : null,
    refreshWarehouses: state.entity.refreshWarehouses ? state.entity.refreshWarehouses : null,
    refreshInventoryAdjust: state.entity.refreshInventoryAdjust ? state.entity.refreshInventoryAdjust : null,
    reStockCapSet: state.entity.reStockCapSet ? state.entity.reStockCapSet : null,
    clickedProduct: state.form.clickedProduct,
    clickedBranch: state.form.clickedBranch,
    typeOfCatergories: state.form.MultiStoreInventoryIsCannabis
  };
};

const mapDispatchToProps = dispatch => {
  return {
    clearFormInput: (name) => dispatch(clearFormInput(name)),
    formInput: (value, name) => dispatch(formInput(value, name)),
    GetProductInventoryLog: model => dispatch(GetProductInventoryLog(model)),
    getUserBranches: () => dispatch(getUserBranches()),
    getMultiBranchInventory: model => dispatch(getMultiBranchInventory(model)),
    getProductCategories: (isCannabis) => dispatch(getProductCategoriesDropdown(isCannabis)),
    getSingleBranchInventory: model => dispatch(getSingleBranchInventory(model)),
    getCsvReport: (url, name) => dispatch(getCsvReport(url, name))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(multiStoreManagement);
